import {
  MerchantSearchResult,
  VenueSearchResult,
  SearchResult,
} from 'apis/restaurant-api/merchant-admin/venue-search/types';

import { MINIMUM_SEARCH_LEN } from './constants';

export const isMerchantResult = (result: SearchResult): result is MerchantSearchResult => result.type === 'merchant';
export const isVenueResult = (result: SearchResult): result is VenueSearchResult => result.type === 'venue';

export const getInitialsFromLabel = (label: string): string => label.charAt(0);

export const isValidSearchQuery = (input: string) => input.length >= MINIMUM_SEARCH_LEN;
